import React from 'react';
import Payment_Success from '../../component/Payment_Success';
import './style.scss';

const PaymentSuccess = () =>{
    return(
        <div className='payment_success'>
            <Payment_Success/>
        </div>
    )
}

export default PaymentSuccess;